import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import type React from 'react';
import styled from 'styled-components';

import type { Currency } from '../../../../../types/currency';
import { formatPrice } from '../../../../shared/helpers';

const QuantityInput = styled.input`
  width: 3rem;
`;

type Props = {
  currency?: Currency;
  quantity: number;
  price: number;
  disabled?: boolean;
  strikethrough: boolean;
  subtotal: number;
  onChangeQuantity: (_: React.ChangeEvent<HTMLInputElement>) => void;
};

const AdjustableQuantityItem = ({
  currency,
  quantity,
  price,
  disabled = false,
  strikethrough,
  subtotal,
  onChangeQuantity,
}: Props) => (
  <SRow>
    <SCol span='8'>
      <QuantityInput
        aria-label={t('client.accessibility.offer-quantity')}
        data-ref='offer.quantity-input'
        type='number'
        value={quantity}
        disabled={disabled}
        onChange={onChangeQuantity}
        className='inline margin-right-xs'
      />
      x {formatPrice(price, 2, currency)} =
    </SCol>
    <SCol span='4' className={`text-right align-self-center${strikethrough ? ' text-strikethrough' : ''}`}>
      {formatPrice(subtotal, 2, currency)}
    </SCol>
  </SRow>
);
export default AdjustableQuantityItem;
